import { render, staticRenderFns } from "./result-card-footer.component.vue?vue&type=template&id=928eefd2&scoped=true"
import script from "./result-card-footer.component.vue?vue&type=script&lang=ts"
export * from "./result-card-footer.component.vue?vue&type=script&lang=ts"
import style0 from "./result-card-footer.component.vue?vue&type=style&index=0&id=928eefd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928eefd2",
  null
  
)

export default component.exports